export enum ErrorMessage {
  AlreadySubmitted = "Already submitted",
  Expired = "Expired",
}
